module.exports = __webpack_public_path__ + "static/img/bxslb.122201f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/bxslb.png
// module id = 4Heg
// module chunks = 0